
module.exports = {
  address: '0xD22E79BFB566697657b967E0ca8F9194719bA551',
  address_test: '0xDdb1259D3707eBF95F036A2Ab44Cb32A4e09795a',
  abi: require('./StakeMiner.abi.json')
}
